import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handlevehicleShortageSummaryMasterList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const vehicleShortageSummaryMasterAsync=createAsyncThunk(
   "companyMaster/list",
   async ({ data, done, err }, thunkAPi) => {
      try {
         
         
         const { data: response } = await handlevehicleShortageSummaryMasterList(data);
         if (response.statusCode === 200) {
            done && done(response.res);
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const vehicleShortageSummaryReportMasterSlice = createSlice({
   name: "companyMaster",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(vehicleShortageSummaryMasterAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(vehicleShortageSummaryMasterAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(vehicleShortageSummaryMasterAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default vehicleShortageSummaryReportMasterSlice.reducer;